import { render, staticRenderFns } from "./DisapproveChallengeModal.vue?vue&type=template&id=45ec9b31&scoped=true&"
import script from "./DisapproveChallengeModal.vue?vue&type=script&lang=js&"
export * from "./DisapproveChallengeModal.vue?vue&type=script&lang=js&"
import style0 from "./DisapproveChallengeModal.vue?vue&type=style&index=0&id=45ec9b31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ec9b31",
  null
  
)

export default component.exports